import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyStatusV2Service {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProductos(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + idEmpresa );
  }

  getProrrogasFechaCierre(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getProrrogasFechaEncuesta + datos);
  }

  getStatusBanderaProrroga(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getBanderasProrroga + idEmpresa + "/" + idProducto);
  }

  getPilotoDataEncuesta_estatus(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.envioCorreo.getPilotoData + idEmpresa, datos);
  }

  getAvanceEncuesta(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cierre.getAvanceEncuesta + idEmpresa, datos);
  }

  getPilotoData_Pulse(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getEncuetasPulsePiloto + idEmpresa, datos);
  }

  getFechasProgramacionPulse_status(datos: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha + idEmpresa, datos);
  }

  surveyCheck(token:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.surveyCheck + token);
  }

  getPilotoData_medir(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.envioCorreo.getPilotoData + idEmpresa, datos);
  }

  getAvanceEncuestaMedir(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.cierre.getAvanceEncuesta + idEmpresa, datos);
  }

  getFechaLanzamientoStatusEncuesta(empresaId:any,data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento + empresaId, data);
  }

  getEstatusCierreEncuesta(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getStatusEncuesta + datos);
  }

  getFechaLanzamiento35_req(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getfecha35 + idEmpresa, datos);
  }

  normaCloseSurvey(productoId:number, tipoEncuesta:number, idEmpresa:string){
    let datos: any = { productoId, tipoEncuesta};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + idEmpresa, datos);
  }

  getMostrarEncuestas(datos:any, idEmpresa:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getEncuestas + idEmpresa, datos);
  }

  desColaboradores(idSurvey1:any ,idSurvey2:any ,bandera:any ,instituto:any, tokenConfig:any){
    let datos: any = {bandera, instituto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.downloadCol + idSurvey1 + '/' + idSurvey2 + '/' + tokenConfig, datos);
  }

  desColaboradoresV2(idSurvey1:any ,idSurvey2:any ,bandera:any, nombre:string, tokenConfig:any){
    let datos: any = {bandera};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.status_survey_getcolaboradores + idSurvey1 + '/' + idSurvey2 + '/' + nombre + '/' + tokenConfig, datos);
  }

  getCatalogos(numInstituto:any, idioma:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto + "/" + idioma);
  }

  buscaOwnkey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaOwnkey + idProducto, datos);
  }
  buscaBossKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaBossKey + idProducto, datos);
  }
  buscarSurveyKey(idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarSurveyKey + idProducto, datos);
  }
  buscarEmail(idProducto:string, email:string, paramExtra:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscaEmail + idProducto + "/" + email + "/" + paramExtra);
  }
  updateColaborador(idColaborador:string, idSurvey:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey, datos);
  }
  updateColaboradorFocus(idColaborador:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.update_fa + idColaborador, datos);
  }
  saveColaboradorNuevo(idEmpresa:string, idProducto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save + idEmpresa + '/' + idProducto, datos);
  }
  saveColaboradorNuevoFocus(idEmpresa:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.save_fa + idEmpresa, datos);
  }

  getInfoColabaradorPorPassword(productoId,password){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.buscarColaboradorPassword+productoId+'/'+ password);
  }

  getColaboradorFstStp(correo:string, productoId:string){
    let datos: any = {search : correo,page :1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.consultarUusuario+productoId, datos);
  }

  getColaborador(idColaborador:string, idSurvey:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey);
  }

  deleteColaborador(idColaborador:string, idSurvey:string,tokenConfig:any){
    return this.http.delete(DATOS_API.url + DATOS_API.endpoints.addColabsSurvey.getSetDelColaborador + idColaborador + "/" + idSurvey+ "/" + tokenConfig, {});
  }
  resetSurvey(idColaborador:string, idSurvey:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resetSurvey + idColaborador + "/" + idSurvey, {});
  }

  getRecordatorios_correo_statussurvey(datos:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getemailreminder + idEmpresa, datos);
  }

  CertificarsendRecordatorio_statusSurvey(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendreminder + idEmpresa, datos);
  }

  CertificarsendRecordatorio_statusSurveySMTP(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTP + idEmpresa, datos);
  }

  Certificar3sendRecordatorio_statusSurveySMTP(productoId,empresaId){
    let datos: any = {productoId, empresaId, tipos:[6,7]};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTPCer3, datos);
  }

  getRecordatorios_correoGenerico_status(datos:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getMedirGenerico + idEmpresa, datos);
  }

  sendRecordatorioMedirGenerico_status(productoId,idEmpresa){
    let datos: any = {productoId};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.sendreminderMedirGenerico + idEmpresa, datos);
  }

  getRecordatoriosPulse_status(datos,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getRecordatoriosPulseManuales + idEmpresa, datos);
  }

  sendRecordatoriosPulse_status(datos,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.sendRecordatoriosPulse + idEmpresa, datos);
  }

  send_email(datos:any, idEmpresa:any, idProducto:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.send_email + idEmpresa + '/' + idProducto, datos);
  }

  delete_surveyAnswer(idColaborador:string, instituto:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.delete_answer + idColaborador + '/' + instituto, datos);
  }

  getInfoEmpresa(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
  }

  sincronizarConteos(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sincronizar, datos);
  }

  actualizaEstatusCierreEncuesta(empresaId:any, productoId:any, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.cerrarEncuesta + empresaId + '/' + productoId, datos);
  }

  cierreManual(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cierreManual, datos);
  }

  saveProrroga(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.saveFechaProrroga ,datos);
  }

  actualizarFechadeCierre(data:any, idEncuesta?:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateEndDate, data);
  }

  informacion_template(idEmpresa:string, data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.templateCorreo.empresaTemplate + idEmpresa, data);
  }

  getStatusEmail(correo:string, asunto:string){
    let datos = { correo, asunto };
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusEmail, datos);
  }

  saveConteosClaves(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveConteosClave, datos);
  }

  getClaveConteos(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getClaveConteo, datos);
  }

  getClavesConteosPulse(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getClavesConteosPulse, datos);
  }

  getMasterTable(surveyToken: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getMasterTable + surveyToken);
  }
   updateNameIconEmpresa(empresaId:any, productoId:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateNameIcon + empresaId+'/'+productoId,{});

   }

   regenerateCerti(datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.regenerateCertify,datos);

   }
  getLogEmails(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getLogEmails, datos);
  }

  getTiposCorreos(productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.envioManual.getTipos + productoId);
  }

  enviarCorreos(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.envioManual.enviarCorreos, datos);
  }

  getBanderasProducto(idEmpresa: string, idProducto: string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.getBanderasConfiguracion + idEmpresa + "/" + idProducto);
  }
  setVersionSGO(idEmpresa: string, idProducto: string, datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.setVersionSGO + idEmpresa + "/" + idProducto, datos);
  }
  obtenerPilito(idEmpresa: string,productoid:any){
    let productoId: any = productoid
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getPilot + idEmpresa, productoId);
  }

  getBrokerConfig(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.brokerConfig);
  }

  getJsonLogos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.getJsonLogos + localStorage.getItem('companyID') + "/" + localStorage.getItem('productoID'));
  }
  updateJsonLogos(jsonId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.updateJsonLogos + jsonId, datos);
  }

  getInfoAudManual(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.auditManual.get + localStorage.getItem('companyID') + "/" + localStorage.getItem('productoID'));
  }
  setInfoAudManual(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.auditManual.set + localStorage.getItem('companyID'), datos);
  }
  getLogoEmpresa(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getLogoEmpresa + localStorage.getItem('companyID'));
  }
  saveLogoEmpresa(datos: any) {
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.logoEmpresa + localStorage.getItem('companyID'), datos);
  }

  getHistoryEmailColab(productoId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getHistoryEmailColab + productoId);
  }

  getAutomatedAuditInfo(productoId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getAutomatedAuditInfo + localStorage.getItem('companyID')+"/"+productoId);
  }
  getInfoEmailStatus(datos: any) {
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getInfoEmailStatus, datos);
  }


  getEventsXEmailMessageId(productoId: any,tipo: any,email: any,messageId:any) {
    return this.http.get(DATOS_API.urlSengridWebHook + DATOS_API.endpoints.logSengridEmailStatus.getInfoEventIndivEmail+ productoId+"/"+tipo+"/"+email+"/"+messageId);
  }

  getAllGlobalEmailStatus(productoId: any) {
    return this.http.get(DATOS_API.urlSengridWebHook + DATOS_API.endpoints.logSengridEmailStatus.getAllGlobalEmailStatus+ productoId);
  }

  getInfoEventGralColabEmail(productoId: any,tipo:any,status:any) {
    return this.http.get(DATOS_API.urlSengridWebHook + DATOS_API.endpoints.logSengridEmailStatus.getInfoEventGralColabEmail+  productoId+"/"+tipo+"/"+status);
  }

  getLogStatusEmailColab(data: any) {
    return this.http.post(DATOS_API.urlSengridWebHook + DATOS_API.endpoints.logSengridEmailStatus.getLogStatusEmailColab,data);
  }

  postliberaciónCultureBrief(datos: any) {
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.postliberaciónCultureBrief+ localStorage.getItem('companyID'), datos);
  }

  setFlagsConfig(datos:any, idEmpresa?:string, idProducto?:string){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setCertificar + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfig(idEmpresa?:string, idProducto?:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getCertificar + idEmpresa + "/" + idProducto);
  }
  actualizaTextoCertificado(empresaId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.actualizaTextoCertificado + empresaId, datos);
  }
  getTextoCertificado(surveyToken:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.getTextoCertificado + surveyToken);
  }
  getBloqueoResultados(surveyToken:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.bloqueoResultados.get + surveyToken);
  }
  setBloqueoResultados(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.bloqueoResultados.set, datos);
  }
  updateMasterTable(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateMasterTable, datos);
  }

  getUrlCA_Cert3(productoId:string, lang:string, user:string){
    let datos = { productoId, lang, user };
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCultureAudit + localStorage.getItem('companyID'), datos);
  }
  getUrlCA_CGOX(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCultureAuditCGOX + localStorage.getItem('companyID'), datos);
  }


  getCertificateDate(empresaId:any,productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCertificateDate + empresaId +'/'+productoId);
  }

  updateCertificateDate(empresaId:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateCertificateDate + empresaId, datos);
  }

  registerDate2(data){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc2+localStorage.getItem('companyID'),data);
  }
  updateFechaCierreUsuarioEmpresa(datos:any){
    console.log(datos);
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.fechaCierre.updateFechaCierreUsuario,datos);
  }
  cancelarEnvios(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.cancelarEnvios + localStorage.getItem('companyID'), datos);
  }
  getFlagSuccesGo(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFlagSuccesGo);
  }

  getDateLanNormv2(idEmpresa:any,productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getDateLanzV2 +idEmpresa+'/'+productoId);
  }

  registerDateLanNormv2(idEmpresa:any,data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveDateLanzV2 +idEmpresa,data);
  }
  setConfigVoiceSection(idEmpresa:any,data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateConfigVoiceSection +idEmpresa,data);
  }

  getStatusDemographicsPdf(productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getStatusDemographicsPdf +productoId);
  }

  setEnableDemographicsPdf(productoId:any,broker:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.setEnableDemographicsPdf +productoId+'/'+broker,datos);
  }

  updateDataWPC(companyId:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateDataWPC +companyId,datos);
  }
  getdataWPC(companyId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getdataWPC +companyId);
  }

  getMarkCultureAudit(companyId:any,productoId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getMarkCultureAudit +companyId+'/'+productoId);
  }
  postMarkCultureAudit(companyId:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.postMarkCultureAudit +companyId,datos);
  }

  asociarCultureBrief(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.asociarCultureBrief + localStorage.getItem('companyID'), datos);    
  }

}
